import clsx from 'clsx';
import { FC } from 'react';
import { createPortal } from 'react-dom';
import styles from './Notice.module.css';
import { useNotice } from './useNotice';
import { FormattedMessage } from 'react-intl';

export const Notice: FC = () => {
  const [state, notice] = useNotice();

  return createPortal(
    <div
      className={clsx(
        styles.notice,
        { [styles.visible]: state === 'show' },
        notice?.variant ? styles[notice.variant] : styles.primary
      )}
    >
      {notice?.message && <FormattedMessage id={notice.message} />}
    </div>,
    document.getElementById('root')!
  );
};
